var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "time-tracking__project hover-highlight q-py-xs q-px-sm row items-center justify-between no-wrap",
      class: { "cursor-pointer": _vm.clickable },
      style: { "background-color": _vm.active ? _vm.activeColor : null },
      on: {
        click: function($event) {
          _vm.$emit("click", $event)
        }
      }
    },
    [
      _c("div", { staticClass: "col-auto row items-center no-wrap" }, [
        _c("div", [
          _c("div", {
            staticClass: "time-tracking__project__color-indicator circle",
            style: { "background-color": _vm.projectColor }
          })
        ]),
        _c(
          "span",
          {
            staticClass: "q-subheading block on-right ellipsis",
            style: { color: _vm.projectColor }
          },
          [_vm._v(_vm._s(_vm.projectName))]
        )
      ]),
      _vm.hasCustomer && !_vm.hideCustomer
        ? _c("div", { staticClass: "col row items-center justify-end" }, [
            _c(
              "span",
              { staticClass: "q-body-1 text-faded block ellipsis on-right" },
              [_vm._v(_vm._s(_vm.customerName))]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }